// extracted by mini-css-extract-plugin
module.exports = {"borderStyle":"style_borderStyle___AggB","overlayLink":"style_overlayLink__dFNCU"};